import BizkeytechApiService from "../../../../@bizkeytech/base/core/services/api";
import {BizFileController, InventoryController, OperatorController, PlanningController, PurchasePlanningController, ReportingToolsController, SettingController, UiComponentsController,} from './v1';

/**
 * The interface that houses all the available api calls related to this application.
 */
class BizProductionApiService extends BizkeytechApiService {

    /**
     * The v1 controllers of the api service.
     * We have to use this getter to access the controllers of the api service since executor is set way later in runtime.
     */
    public static get v1() {
        return {
            bizFile: new BizFileController(this.executor),
            setting: new SettingController(this.executor),
            reportingTools: new ReportingToolsController(this.executor),
            operator: new OperatorController(this.executor),
            uiComponent: new UiComponentsController(this.executor),
            planning: new PlanningController(this.executor),
            purchasePlanning: new PurchasePlanningController(this.executor),
            inventory: new InventoryController(this.executor),
        }
    }

}

export type * as ApiServiceModels from './v1';
export * from './v1';
export default BizProductionApiService;
